import React from 'react';

import { reloadDocument } from '../../lib/desktop_navigation_diagnostics';

interface FeedErrorBoundaryProps {
  readonly children: React.ReactNode;
}

interface FeedErrorBoundaryState {
  readonly failed: boolean;
}

/** Keeps MessageFeed render failures from unmounting the rest of the React app. */
export class FeedErrorBoundary extends React.Component<FeedErrorBoundaryProps, FeedErrorBoundaryState> {
  constructor(props: FeedErrorBoundaryProps) {
    super(props);
    this.state = { failed: false };
    this.handleReload = this.handleReload.bind(this);
  }

  static getDerivedStateFromError(): FeedErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('[MessageFeed] render error:', error, errorInfo);
  }

  handleReload(): void {
    reloadDocument('error-boundary-recovery');
  }

  render(): React.ReactNode {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="flex h-full min-h-64 items-center justify-center px-4 py-8">
        <div className="flex w-full max-w-sm flex-col items-center gap-3 rounded-md border border-neutral-200 bg-white p-4 text-center shadow-sm dark:border-neutral-800 dark:bg-neutral-950">
          <p className="text-sm font-medium text-neutral-950 dark:text-neutral-50">Messages failed to render.</p>
          <button
            className="inline-flex cursor-pointer items-center justify-center rounded-md bg-neutral-950 px-3 py-2 text-sm font-medium text-white hover:bg-neutral-800 dark:bg-neutral-50 dark:text-neutral-950 dark:hover:bg-neutral-200"
            onClick={this.handleReload}
            type="button"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
